// extracted by mini-css-extract-plugin
module.exports = {"root":"PrintSinglePreviewLayout_root__avq_X"};